import React from 'react';
import styles from "../../../../../styles/pages/Lead/LeadManagement/InfoComponents/KycData.module.css";


export const KycSalesData = ({ fields, renderField }) => {
    return (
        <div className={styles.kycGridContainer}> 
            <div className={styles.infoGrid}> 
                {fields.map(renderField)}
            </div>
        </div>
    );
};